// useTextGenerator.ts
import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';

import { initializeTracking } from '@/app/[locale]/app-api/usertracking/user-information';
import { generateFingerprint } from '@/utils/Fingerprint';

const useTextGenerator = () => {
  const intl = useIntl();

  const placeholderText = intl.formatMessage({
    id: 'home.text-generator.textarea.placeholder',
    defaultMessage: 'e.g Write a blog post about the benefits of exercise'
  });

  useEffect(() => {
    const setupTracking = async () => {
      const toolName = 'textGenerationLimit';
      const { fingerprint } = await generateFingerprint(); // Use the existing fingerprint generation
      setFingerPrint(fingerprint);
      await initializeTracking(fingerprint, toolName, setCounter); // Initialize tracking with the fingerprint
    };

    setupTracking();
  }, []);

  const [inputText, setInputText] = useState('');
  const [tone, setTone] = useState('formal');
  const [length, setLength] = useState('compact');
  const [language, setLanguage] = useState('German');
  const [model, setModel] = useState('GPT-4o mini');
  const [fingerPrint, setFingerPrint] = useState('');
  const [loading, setLoading] = useState(false);
  const [premium, setPremium] = useState(false);
  const [responses, setResponses] = useState<string[]>([]);
  const [streamingResponse, setStreamingResponse] = useState('');
  const [isStreaming, setIsStreaming] = useState(false);
  const [counter, setCounter] = useState(3);
  const [isTouched, setIsTouched] = useState(false);
  const [showAd, setShowAd] = useState(!premium);
  const inputRef = useRef<HTMLTextAreaElement | null>(null);
  return {
    placeholderText,
    inputText,
    setInputText,
    tone,
    setTone,
    length,
    setLength,
    language,
    setLanguage,
    model,
    setModel,
    fingerPrint,
    setFingerPrint,
    loading,
    setLoading,
    premium,
    setPremium,
    responses,
    setResponses,
    streamingResponse,
    setStreamingResponse,
    isStreaming,
    setIsStreaming,
    counter,
    setCounter,
    isTouched,
    setIsTouched,
    showAd,
    setShowAd,
    inputRef
  };
};

export default useTextGenerator;
